<template>
  <div class="login">

    <TemplateAuth>
      <div class="wrapper">
        <SelectLanguage/>
        <Header icon="user" description="YOUR PRACTICE...DIGITAL"/>
        <Title :title="$t('auth_title_login')"/>
        <el-row :gutter="20" type="flex" justify="center" class="width-100">
          <el-col :span="24">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="0" class="demo-ruleForm">

              <el-form-item prop="email">
                <el-input @keyup.enter.native="submitForm('form')" v-model="form.email" :label="$t('auth_form_email')"></el-input>
              </el-form-item>

              <el-form-item prop="password">
                <el-input @keyup.enter.native="submitForm('form')" type="password" v-model="form.password" :label="$t('auth_form_password')" show-password></el-input>
              </el-form-item>

              <el-form-item prop="timeRange">
                <el-select class="width-100" v-model="form.timeRange"  placeholder="Set Login Period (Hrs: Mins)" clearable filterable>
                  <el-option v-for="item in timeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div class="question">
                  <el-tooltip class="item" effect="dark" content="Not recomended to set long period if other people use this device." placement="right">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
              </el-form-item>

              <el-form-item v-if="!resend">
                <el-button type="primary" class="width-100" @click="submitForm('form')">{{$t('auth_btn_login')}}</el-button>
              </el-form-item>

              <el-form-item v-if="resend">
                <el-button type="warning" class="width-100" @click="resendConfirm()">{{$t('auth_btn_resend_confirm')}}</el-button>
              </el-form-item>

            </el-form>
          </el-col>
        </el-row>

        <el-row :gutter="20" type="flex" justify="center" class="row-padding footer__link">
          <el-col :span="24">
            <div style="margin-bottom: 10px;">
              <!-- {{$t('auth_forgot_password')}} -->
              Forgot Your Password?
              <router-link :to="{ name: 'reset' }">
                <!-- {{$t('auth_reset')}} -->
                Click here
              </router-link>
            </div>
            <!-- <div>
              {{$t('auth_try_free')}}
              <router-link :to="{ name: 'signup' }">{{$t('auth_signup')}}</router-link>
            </div> -->
            <div>
              By clicking Log In, you agree to our <span class="link-terms" @click="openLink('termsOfUse')">Terms and Conditions</span>. Learn how we process your data in our <span class="link-terms" @click="openLink('privacyNotice')">Privacy Policy</span>.
              <!-- I have read and I agree to the <span class="link-terms" @click="openLink('termsOfUse')"> terms of use</span>, <span class="link-terms" @click="openLink('privacyNotice')">privacy notice</span> and <span class="link-terms" @click="openLink('offerDetails')">offer details</span> -->
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" type="flex" justify="center" class="row-padding footer__link">
          <el-col :span="24">
            <div class="copywriting">
              © {{ moment().year() }} 3030 Technologies. All rights reserved.
            </div>
          </el-col>
        </el-row>
      </div>
    </TemplateAuth>

    <info-modal ref="infoModal" :title="info.title">
      <div v-html="info.text"></div>
    </info-modal>

  </div>
</template>

<script>
import TemplateAuth from '@/components/auth/TemplateAuth.vue'
import log from '@/log/log.js'
import moment from 'moment'
import '../../../errorHandler.js'
import SelectLanguage from '@/components/SelectLanguage.vue'
import Header from '@/components/auth/Header.vue'
import Title from '@/components/auth/Title.vue'
import InfoModal from '@/components/InfoModal.vue'
import axios from 'axios'
  export default {
    name: 'login',
    components: {
      TemplateAuth,
      SelectLanguage,
      Header,
      Title,
      InfoModal,
    },
    beforeCreate() {},
    mounted () {
      this.getLinksList()
    },
    data() {
      return {
        moment: moment,
        resend: false,

        info: {
          title: '',
          text: ''
        },
        linksList: null,

        form: {
          email: '',
          password: '',
          timeRange: ''
        },
        rules: {
          email: [
            { required: true, message: 'Please input Email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Please input Password', trigger: 'blur' },
            { min: 8, message: 'Length should be 8', trigger: 'blur' }
          ],
          timeRange: [
            { required: true, message: 'Please input Time', trigger: 'change' }
          ]
        },
        timeList: [{value: '00:30', label: '00:30'}, {value: '01:00', label: '01:00'}, {value: '01:30', label: '01:30'}, {value: '02:00', label: '02:00'}, {value: '02:30', label: '02:30'}, {value: '03:00', label: '03:00'}, {value: '03:30', label: '03:30'}, {value: '04:00', label: '04:00'}, {value: '04:30', label: '04:30'}, {value: '05:00', label: '05:00'}, {value: '05:30', label: '05:30'}, {value: '06:00', label: '06:00'}, {value: '06:30', label: '06:30'}, {value: '07:00', label: '07:00'}, {value: '07:30', label: '07:30'}, {value: '08:00', label: '08:00'}],
        redirect: undefined,
        lastCompanyId: undefined
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    sockets: {
      connect: function () {
          console.log('socket connected')
      },
      customEmit: function (data) {
          console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      }
    },
    methods: {
      openLink(name) {
        if (!this.linksList) return
        this.info.title = this.linksList[name].translations[0].titleTranslation
        this.info.text = this.linksList[name].translations[0].textTranslation
        this.$refs['infoModal'].openModal()
      },
      getLinksList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/terms-and-conditions/list-by-lang?code=${localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'}`)
          .then(response => {
            loader.hide()
            const obj = {}
            response.data.list.forEach(element => {
              obj[element.code] = element
            });
            this.linksList = obj
          })
          .catch(error => {
            loader.hide()
          });
      },
      clickButton(val) {
        // this.$socket is `socket.io-client` instance
        this.$socket.emit('emit_method', val);
      },
      submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();

            const currentTime = moment().format('x');
            const time = moment().add(Number(this.form.timeRange[1]), 'h').add(Number(this.form.timeRange.slice(-2)), 'm').format('x');
            const result = Math.floor((Number(time) - Number(currentTime)) / 1000);

            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post('/api/v1/auth/login', {
                email: this.form.email,
                password: this.form.password,
                timeRange: result,
                system: 'totalflow'
              })
              .then( async response => {
                try {
                  // Handle success.
                  sessionStorage.setItem('token', response.data.token);
                  // set session timer
                  // this.$session.set('timer', result);
                  sessionStorage.setItem('timer', result.toString());
                  this.setLang(response.data.token);

                  const user = await this.$store.dispatch('loadUser');

                  // find if user have access from redirect url company id
                  const redirectedCompanyIdLength = user.companyList.filter(val => val.id === this.lastCompanyId).length;

                  // find last active campaign from company list
                  if (user.companyList.length && user.lastCompanyId) {
                    const lastCompany = user.companyList.filter(val => val.id === user.lastCompanyId);

                    if (lastCompany.length) {
                      await this.$store.dispatch('toggleActiveCompanyName', lastCompany[0].name);
                      localStorage.setItem('companyId', lastCompany[0].id);
                      await this.$store.dispatch('companyChange', user.lastCompanyId);

                      const companyLayout = await this.$store.dispatch('getCompanyLayout', user.lastCompanyId);

                      console.log('companyLayout', companyLayout);

                      const data = {
                        companyId: user.lastCompanyId,
                        companyUserId: companyLayout.companyUserId
                      };

                      this.$socket.emit('companyChanged', data);

                      const menuStatistics = await this.$store.dispatch('getMenuStatistics', user.lastCompanyId);

                      if(menuStatistics.lastProjectId !== null){
                        localStorage.setItem('selectedProjectId', menuStatistics.lastProjectId);
                        this.$router.push({path: redirectedCompanyIdLength ? this.redirect : `/projects?companyId=${user.lastCompanyId}&projectId=${menuStatistics.lastProjectId}&taskId=${0}`})
                      }else{
                        this.$router.push({path: redirectedCompanyIdLength ? this.redirect : `/projects?companyId=${user.lastCompanyId}` })
                      }
                    }
                  } else if (user.lastCompanyId === null){
                    this.$router.push( {path: redirectedCompanyIdLength ? this.redirect : '/projects'})
                  } else {
                    const companyLayout = await this.$store.dispatch('getCompanyLayout', user.companyList[0].id);

                    const data = {
                      companyId: user.companyList[0].id,
                      companyUserId: companyLayout.companyUserId
                    };
                    this.$socket.emit('companyChanged', data);

                    await this.$store.dispatch('companyChange', user.companyList[0].id);
                    await this.$router.push({path: redirectedCompanyIdLength ? this.redirect : `/projects?companyId=${user.companyList[0].id}`})
                  }

                  // Log
                  // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  // axios.post(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
                  //   'action': 'login',
                  //   'paramsLog': {}
                  // })
                  //   .then(response => {
                  //     console.log('response', response.data)
                  //   })
                  //   .catch(error => {
                  //     console.log('An error occurred:', error);
                  //   });

                  // Log login
                  // log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
                  //   'action': 'log_login',
                  //   'paramsLog': {}
                  // })

                  loader.hide()
                } catch (err){
                  console.log(err)
                }
              })
              .catch(error => {
                loader.hide();
                if(error.response){
                  if(error.response.data.message === 'user_not_confirmed'){
                    this.resend = true
                    return
                  }else{
                    return
                  }
                }
                this.notification("Notification", error, "info")
                // loader.hide()
                // console.log('resend', this.resend)
                // Handle error.
                // console.log('An error occurred:', error);
                // if (error.response.data.message == 'user_not_confirmed') {
                //   this.notification("Info", "Resend Confirm", "info")
                //   this.resend = true
                // } else {
                //   this.notification("Notification", error.response.data.message, "info")
                // }
                // loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      setLang(token){
        let loader = this.$loading.show();
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .get(localStorage.getItem('lang') ? `/api/v1/translations/lang?token=${token}&lang=${localStorage.getItem('lang')}` : `/api/v1/translations/lang?token=${token}`)
                .then(response => {
                  console.log("languages", response.data)
                  this.$i18n.setLocaleMessage(response.data.language, response.data)
                  console.log('MY LANG', response.data.language)
                  localStorage.setItem('lang', response.data.language);
                  this.$i18n.locale = response.data.language
                  console.log("l18n", this.$i18n)
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      resendConfirm() {
        console.log('---resendConfirm', 'AAAAAAAAAAA');

        let loader = this.$loading.show();
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post('/api/v1/auth/resendConfirm', {
            email: this.form.email
          })
          .then(response => {
            // Handle success.
            console.log('---', response.data);
            this.notification("Success", "Confirmation mail has send to you, please check your email", "success")
            this.resend = false
            loader.hide()
          })
          .catch(error => {
            // Handle error.
            console.log('An error occurred:', error);
            this.notification("Notification", error.response.data.message, "info")
            loader.hide()
          });
      }
    },
    watch: {
      $route: {
        handler: function(route) {
          console.log('ROUTE', route)
          this.redirect = route.query && route.query.redirect;
          if (route.query.redirect){
            this.lastCompanyId = route.query && Number(route.query.redirect.match(/\d/g).join(""));
          }
          if (route.query) {
            for(let i in route.query){
              if (i !== 'redirect'){
                this.redirect = this.redirect + '&' + i + '=' +route.query[i];
              }
            }
          }
        },
        immediate: true
      }
    },
  }
</script>

<style lang="scss" scoped>
.question {
  font-size: 14px;
  position: absolute;
  top: 0;
  right: -10px;
  color: #409EFF;
}
.login {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  /*width: 100vh;*/
	// height: 100vh;
  // text-align: center;
  // padding: 0 20px;

  .wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    position:relative;
    box-sizing: border-box;
    // max-width: 350px;
    width: 100%;
    padding: 40px 35px;
    background: #ffffff;
    // box-shadow: 0 0 15px rgba(0,0,0,0.5);
  }
  .width-100 {
    width: 100%;
  }
  .mb {
  margin-bottom: 20px;
  }
}

.footer__link {
  line-height: 1.6;
  color: #909399;
}

.row-padding {
  padding: 10px 0;
}

.copywriting {
  margin-top: 30px;
  color: #000;
}
</style>
